var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"rotator","frameborder":"0","scrolling":"no","src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }